webpackJsonp([2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(8);
	
	__webpack_require__(158);

/***/ },

/***/ 154:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	LoginForm.$inject = ["loginService"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loginForm = __webpack_require__(225);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*@ngInject*/
	function LoginForm(loginService) {
	    var loginForm = this;
	    loginForm.loginData = {
	        agencyId: '',
	        userName: '',
	        password: ''
	    };
	
	    loginForm.isLoginFailed = false;
	
	    loginForm.isLoading = false;
	
	    loginForm.login = login;
	
	    function login() {
	        loginForm.isLoginFailed = false;
	        loginForm.isLoading = true;
	        loginService.login(loginForm.loginData).catch(function () {
	            onLoginFailed();
	            loginForm.isLoading = false;
	        });
	    }
	
	    function onLoginFailed() {
	        loginForm.isLoginFailed = true;
	    }
	}
	
	exports.default = {
	    templateUrl: _loginForm2.default,
	    controller: LoginForm,
	    controllerAs: 'loginForm'
	};

/***/ },

/***/ 155:
/***/ function(module, exports) {

	'use strict';
	
	loginService.$inject = ["$http", "externalRedirect"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* @ngInject */
	function loginService($http, externalRedirect) {
	    var URL = 'api/session/login';
	
	    return {
	        login: login
	    };
	
	    ////////////////
	
	    /**
	     * @param loginData
	     * {
	     *   agencyId: '123456789',
	     *   userName: 'agency user name',
	     *   password: 'agency password'
	     * }
	     * @returns a Promise
	     */
	    function login(loginData) {
	        var request = {
	            agencyId: loginData.agencyId,
	            userName: loginData.userName,
	            password: loginData.password
	        };
	
	        return $http.post(URL, request).then(loadComplete);
	    }
	
	    function loadComplete(response) {
	        var data = response.data;
	
	        externalRedirect.redirect(data.redirect);
	    }
	}
	
	exports.default = loginService;

/***/ },

/***/ 156:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loginHeader = __webpack_require__(226);
	
	var _loginHeader2 = _interopRequireDefault(_loginHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    templateUrl: _loginHeader2.default
	};

/***/ },

/***/ 157:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _login = __webpack_require__(227);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	    templateUrl: _login2.default
	};
	
	exports.default = loginComponent;

/***/ },

/***/ 158:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(4);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _externalRedirect = __webpack_require__(17);
	
	var _externalRedirect2 = _interopRequireDefault(_externalRedirect);
	
	var _loginFormComponent = __webpack_require__(154);
	
	var _loginFormComponent2 = _interopRequireDefault(_loginFormComponent);
	
	var _loginHeaderComponent = __webpack_require__(156);
	
	var _loginHeaderComponent2 = _interopRequireDefault(_loginHeaderComponent);
	
	var _loginService = __webpack_require__(155);
	
	var _loginService2 = _interopRequireDefault(_loginService);
	
	var _login = __webpack_require__(157);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moduleName = 'login';
	
	_angular2.default.module(moduleName, []).factory('externalRedirect', _externalRedirect2.default).factory('loginService', _loginService2.default).component('loginForm', _loginFormComponent2.default).component('loginHeader', _loginHeaderComponent2.default).component('login', _login2.default);
	
	exports.default = moduleName;

/***/ },

/***/ 225:
/***/ function(module, exports) {

	var path = 'app/login/components/form/loginForm.html';
	var html = "<form class=loginForm ng-submit=loginForm.login()> <h2 class=loginForm_headline>Agency Login</h2> <div class=loginForm_formField> <label class=formField_label>Agency #</label> <div> <input ng-model=loginForm.loginData.agencyId class=\"formField_text formField_text-fullWidth\" type=text name=agency_number required> </div> </div> <div class=loginForm_formField> <label class=formField_label>Username</label> <div> <input ng-model=loginForm.loginData.userName class=\"formField_text formField_text-fullWidth\" type=text name=agency_name required> </div> </div> <div class=loginForm_formField> <label class=formField_label>Password</label> <div> <input ng-model=loginForm.loginData.password class=\"formField_text formField_text-fullWidth\" type=password name=agency_password required> </div> </div> <div class=\"loginForm_formField loginForm_formField-loginButton\" ng-if=!loginForm.isLoading> <button type=submit class=\"button button-fullWidth\">Login</button> </div> <div class=loginForm_progressBar ng-if=loginForm.isLoading> <progress></progress> </div> <div class=\"alertBox alertBox-error\" ng-if=loginForm.isLoginFailed> <span class=\"lnr lnr-warning\"></span> <span class=alertBox_message>We are sorry, but your credentials are wrong, please try again</span> </div> </form> <div class=loginForm_registration> Don't have an account? <a href=\"mailto:sales@jactravel.bc.ca?subject=ORCA%20Registration%20Request&body=Please%20register%20me%20as%20a%20user%20on%20the%20ORCA%20website\" target=_top>Register</a> </div> <div class=loginForm_footer> Website best viewed in Internet Explorer 11 and higher, Firefox, Chrome, and Safari </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },

/***/ 226:
/***/ function(module, exports, __webpack_require__) {

	var path = 'app/login/components/header/loginHeader.html';
	var html = "<div class=header> <img class=header_headerImage src=" + __webpack_require__(9) + "> <div class=header_bar> <img class=header_logo src=" + __webpack_require__(10) + "> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ },

/***/ 227:
/***/ function(module, exports) {

	var path = 'app/login/login.html';
	var html = "<login-header></login-header> <div class=view autoscroll=true> <login-form></login-form> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }

});


/** WEBPACK FOOTER **
 ** login.bundle.js
 **/